import { Form } from 'react-bootstrap';
import Select from 'react-select';
import '../BDSMForm.css';

export const FormikSearchMultiSelectInputGroup = ({ field, form, labelText, data }) => {
    const isValid = !form.errors[field.name];
    const isInvalid = form.touched[field.name] && !isValid;

    let byReactSelectModel = data.map(it => ({ value: it.value, label: it.name }));

    return (
        <Form.Group controlId={field.name} className='bdsm-input-group'>
            <Form.Label>{labelText}</Form.Label>
            <div>
                <Select
                    isMulti
                    className='basic-single BDSM-search-multiple-select'
                    classNamePrefix='react-search-select'
                    isSearchable={true}
                    value={field.value}
                    name='react-search-select'
                    options={byReactSelectModel}
                    onChange={(selected) => form.setFieldValue(field.name, selected)}
                />
                {isInvalid
                    ? <div className={'date-picker-errors'}>{form.errors[field.name]}</div>
                    : <></>}
            </div>
        </Form.Group>
    );
};